const couponList = () => import("@/pages/coupon/list/index.vue");
const couponForm = () => import("@/pages/coupon/list/form.vue");
const couponDetail = () => import("@/pages/coupon/list/detail.vue");

export default [
    {
        path: "/coupon/list",
        component: couponList,
        meta: [
            {
                name: "优惠券管理",
                activeRoute: "/coupon/manage",
            },
            {
                name: "优惠券列表",
                activeRoute: "/coupon/list",
            },
        ],
    },
    {
        path: "/coupon/list/form",
        component: couponForm,
        meta: [
            {
                name: "优惠券管理",
                activeRoute: "/coupon/manage",
            },
            {
                name: "优惠券列表",
                url: "/coupon/list",
            },
            {
                name: "新增/编辑",
                activeRoute: "/coupon/list",
            },
        ],
    },
    {
        path: "/coupon/list/detail",
        component: couponDetail,
        meta: [
            {
                name: "优惠券管理",
                activeRoute: "/coupon/manage",
            },
            {
                name: "优惠券列表",
                url: "/coupon/list",
            },
            {
                name: "领取详情",
                activeRoute: "/coupon/list",
            },
        ],
    },
];
